// component's config object.
import Config from "./Config";


const HCPComponents = {
    HCPDashboard: {
        component: 'HCPDashboardComponent',
        url: '/dashboard',
        access: [Config.roles.Doctor],
        exact: true,
    },
    PatientFormComponent: {
        component: 'PatientFormComponent',
        url: '/dashboard/AddPatient',
        access: [Config.roles.Doctor]
    },
    EditPatientComponent: {
        component: 'EditPatientComponent',
        url: '/dashboard/Patient',
        access: [Config.roles.Doctor]
    },
    NewVisitComponent: {
        component: 'NewVisitComponent',
        url: '/dashboard/NewVisit',
        access: [Config.roles.Doctor]
    },
    VisitReportComponent: {
        component: 'VisitReportComponent',
        url: '/dashboard/visit-report',
        access: [Config.roles.Doctor]
    },
    PatientComponent: {
        component: 'PatientComponent',
        url: '/dashboard/Patient',
        access: [Config.roles.Doctor]
    },
};

const AsayaAdminComponents = {
    AdminDashboardComponent: {
        component: 'AdminDashboardComponent',
        url: '/dashboard',
        access: [Config.roles.SadeAdmin,Config.roles.SadeSuperAdmin],
        exact: true,
    },
};

const rolesConfig = {
    routes: [
        ...Object.values(HCPComponents),
        ...Object.values(AsayaAdminComponents),
    ]
};

export {rolesConfig};
